import $ks from "../lib/ks";
import DrawTimeToClock from "../lib/drawTimeToClock";

class StopWatch {
    constructor(common) {
        this.common = common;

        this.clock = new DrawTimeToClock($ks.getById('stopWatch_clock'));
        this.clockInterval;
        this.clockTime = 0;

        this.startPauseBtn = $ks.getById('stopWatch_btn_startPause');
        this.stopBtn = $ks.getById('stopWatch_btn_stop');
        this.recordBtn = $ks.getById('stopWatch_btn_record');

        this.recordIdx = 0;
        this.recordsCnt = 0;
        this.latestRecord = 0;
        this.recordList = $ks.getById('stopWatch_recordList');
        this.records = [];
    }

    // initialization methods (최초 1회 실행)
    init() {
        this.clock.init().drawTime(0);
        this.setBtns();

        $ks.loadScriptFile('./src/js/lib/jquery.js', function(){
            $ks.loadScriptFile('./src/js/lib/scroll.js', function() {
                $('.scrollOutBox').scrollbar();
            });
        });
        // this.reset();
    }

    setBtns() {
        $ks.addDownEvents(this.startPauseBtn);
        $ks.addHoverEvents(this.startPauseBtn);
        this.startPauseBtn.addEventListener('click', (e) => {
            this.startPauseBtnClickEv(e);
        }, false);

        $ks.addDownEvents(this.stopBtn);
        $ks.addHoverEvents(this.stopBtn);
        this.stopBtn.addEventListener('click', (e) => {
            this.stopBtnClickEv(e);
        }, false);

        $ks.addDownEvents(this.recordBtn);
        $ks.addHoverEvents(this.recordBtn);
        this.recordBtn.addEventListener('click', (e) => {
            this.recordBtnClickEv(e);
        }, false);
    }

    drawRecord() {
        let record, dot;
        record = $ks.ce({
            tag: 'li',
            class: 'stopWatch_record',
        });
        record.number = $ks.ce({
            tag: 'div',
            class: 'stopWatch_record_number',
            targetElement: record
        });
        record.now = $ks.ce({
            tag: 'div',
            class: 'stopWatch_record_now',
            targetElement: record
        });
        record.diff = $ks.ce({
            tag: 'div',
            class: 'stopWatch_record_diff',
            targetElement: record
        });
        record.close = $ks.ce({
            tag: 'div',
            class: 'stopWatch_record_close',
            targetElement: record
        }).addEventListener('click', (e) => {
            $ks.removeClass(e.target.parentNode, 'on');
            this.recordsCnt--;
            $ks.addClass(this.recordBtn, 'on');
        });

        dot = $ks.ce({
            tag: 'span',
            class: 'dot'
        });
        dot.textContent = '.';
        record.nowDrawer = new DrawTimeToClock(record.now);
        record.nowDrawer.init();
        record.nowDrawer.drawTime(0);
        record.now.insertBefore(dot.cloneNode(), $ks.getByClass('ms', record.now, 0));

        record.diffDrawer = new DrawTimeToClock(record.diff);
        record.diffDrawer.init();
        record.diffDrawer.drawTime(0);
        record.diff.insertBefore(dot.cloneNode(), $ks.getByClass('ms', record.diff, 0));

        this.records.push(record);
        this.recordList.appendChild(record);
    }

    // 동작 관련 methods (계속 실행)
    startPauseBtnClickEv(e) {
        if ($ks.hasClass(this.startPauseBtn, 'paused')) {
            $ks.removeClass(this.startPauseBtn, 'paused');
            this.pauseClockInterval();
        } else {
            $ks.addClass(this.startPauseBtn, 'paused');
            $ks.addClass(this.recordBtn, 'on');
            this.startClockInterval();
        }
    }

    stopBtnClickEv(e) {
        this.reset();
    }

    recordBtnClickEv(e) {
        if ($ks.hasClass(this.recordBtn, 'on')) {
            let targetRecord = this.records[this.recordIdx];
            this.recordIdx++;
            this.recordsCnt++;
            $ks.addClass(targetRecord, 'on');
            targetRecord.childNodes[0].textContent = this.recordIdx;
            targetRecord.diffDrawer.drawTime(this.clockTime - this.latestRecord);
            targetRecord.nowDrawer.drawTime(this.clockTime);
            this.latestRecord = this.clockTime;

            this.drawRecord();

            if (this.recordsCnt === 40)
                $ks.removeClass(this.recordBtn, 'on');

            console.log(this.recordList.clientHeight);

            if (this.recordList.clientHeight > 280) $(".scroll-content").scrollTop(this.recordList.clientHeight);
        } else {
        }
    }

    startClockInterval(intervalFn) {
        this.clockInterval = window.setInterval(() => {
            this.clockTime += 1;
            this.clock.drawTime(this.clockTime);
            if (intervalFn) intervalFn();
        }, 10);
    }

    pauseClockInterval() {
        window.clearInterval(this.clockInterval);
        this.clock.drawTime(this.clockTime);
    }

    stopClockInterval() {
        this.clockTime = 0;
        window.clearInterval(this.clockInterval);
        this.clock.drawTime(this.clockTime);
    }

    // 초기화 관련 methods
    reset() {
        this.common.bgSwitcher('stopWatch');
        this.common.turnOnClass(this.common.mains, 'stopWatch', 'on');
        this.common.turnOnClass(this.common.tabs, 'timer', 'on');
        $ks.removeClass(this.startPauseBtn, 'paused');

        this.resetRecords();
        this.stopClockInterval();
    }

    resetRecords() {
        this.records = [];
        this.recordIdx = 0;
        this.recordsCnt = 0;
        this.latestRecord = 0;
        this.recordList.innerHTML = '';
        this.drawRecord();
        $ks.removeClass(this.recordBtn, 'on');
    }
}

export default StopWatch;
